// // hooks/useMomentumScreener.js
// import { useState, useEffect, useCallback, useRef } from "react";
// import axios from "axios";

// const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// const useMomentum = (selectedIndex = "NIFTY 50", autoRefreshMs = 0) => {
//   const [data, setData] = useState([]);
//   const [stats, setStats] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [lastUpdated, setLastUpdated] = useState(null);
//   const intervalRef = useRef(null);

//   const fetchScreener = useCallback(
//     async (showLoader = true) => {
//       if (!selectedIndex) return;

//       if (showLoader) setLoading(true);
//       setError(null);

//       try {
//         // const encodedIndex = encodeURIComponent(selectedIndex.trim());
//         const { data: res } = await axios.post(
//           `${BASE_URL}/api/screener/momentum`,
//           {
//             index: selectedIndex.trim(), // ← match backend's req.body.indexName
//           },
//         );

//         if (res.success) {
//           // ← now checks the actual response body
//           setData(res.data || []); // ← correct path
//           setStats(res.stats || null); // ← correct path
//           setLastUpdated(new Date());
//         } else {
//           setError(res.message || "Failed to fetch screener data");
//           setData([]);
//           setStats(null);
//         }
//       } catch (err) {
//         const msg =
//           err.response?.data?.message || err.message || "Network error";
//         setError(msg);
//         setData([]);
//         setStats(null);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [selectedIndex],
//   );

//   // Fetch on index change
//   useEffect(() => {
//     fetchScreener(true);
//   }, [fetchScreener]);

//   // Auto-refresh
//   useEffect(() => {
//     if (intervalRef.current) {
//       clearInterval(intervalRef.current);
//       intervalRef.current = null;
//     }

//     if (autoRefreshMs > 0) {
//       intervalRef.current = setInterval(() => {
//         fetchScreener(false); // silent refresh, no loader
//       }, autoRefreshMs);
//     }

//     return () => {
//       if (intervalRef.current) clearInterval(intervalRef.current);
//     };
//   }, [autoRefreshMs, fetchScreener]);

//   const refresh = useCallback(() => fetchScreener(true), [fetchScreener]);

//   return {
//     data,
//     stats,
//     loading,
//     error,
//     lastUpdated,
//     refresh,
//   };
// };

// export default useMomentum;

// hooks/useMomentum.js
import { useMemo } from "react";
import useAllMomentum from "./useAllMomentum";

const useMomentum = (selectedIndex = "ALL", autoRefreshMs = 60000) => {
  const {
    data: allData,
    loading,
    error,
    lastUpdated,
    refresh,
  } = useAllMomentum(autoRefreshMs);

  const data = useMemo(() => {
    if (!selectedIndex || selectedIndex === "ALL") return allData;
    const target = selectedIndex.trim().toUpperCase();
    return allData.filter((row) =>
      (row.indexes || []).some((i) => i.trim().toUpperCase() === target),
    );
  }, [allData, selectedIndex]);

  const stats = useMemo(
    () => ({
      total: data.length,
      strong_buy: data.filter((r) => r.momentum_signal === "STRONG BUY").length,
      buy: data.filter((r) => r.momentum_signal === "BUY").length,
      watch: data.filter((r) => r.momentum_signal === "WATCH").length,
      skip: data.filter((r) => r.momentum_signal === "SKIP").length,
    }),
    [data],
  );

  return { data, stats, loading, error, lastUpdated, refresh };
};

export default useMomentum;
